<template>
  <el-dialog :title="$t('file_details')" :visible="visible" :before-close="handleClose">
    <div class="info-box">
      <div class="info-box-img">
        <img :src="item.thumbnail ||
          require(`@/assets/imgs/cloudSpace/default-image.webp`)
          " alt="" />
      </div>
      <div class="info-box-text">
        <div class="info">
          <!-- Name -->
          <div class="info-item">
            <div class="title">{{ $t("name") }}</div>
            <div class="text">
              <span v-show="editInput" :title="item.fileNameStr">{{ item.fileNameStr }}</span>
              <el-input v-show="!editInput" type="text" v-model="str" @keydown.enter.native="nameSumbit"
                @blur="nameSumbit" maxlength="30">
                {{ item.fileNameStr }}
              </el-input>
              <img v-show="editInput" src="@/assets/imgs/materialsEdit.png" alt="" @click="editText" />
            </div>
          </div>
          <!-- Type -->
          <div class="info-item">
            <div class="title">{{ $t("type") }}</div>
            <div class="text">{{ item.file_extension }}</div>
          </div>
          <!-- Size -->
          <div class="info-item">
            <div class="title">{{ $t("size") }}</div>
            <div class="text">{{ item.sizeStr }}</div>
          </div>
          <!-- UploadDate -->
          <div class="info-item">
            <div class="title">{{ $t("upload_date") }}</div>
            <div class="text">{{ item.timeStr }}</div>
          </div>
        </div>
        <div class="edit">
          <!-- default/download/import -->
          <div class="state-icon">
            <!-- default -->
            <button v-if="item.fileStateStr == 'default'" class="file-edit pointer" @click="fileDownload">
              <img src="@/assets/imgs/cloudSpace/Download.webp" alt="" />
              <span>{{ $t("download") }}</span>
            </button>
            <!-- download -->
            <div v-else-if="item.fileStateStr == 'download'" class="downloading">
              <el-progress :percentage="Number(item.downloadPercent) || 0" :show-text="false"></el-progress>
              <span class="downloading-text">{{
                `${$t("downloading_text")}（${item.downloadPercent || 0}%）`
              }}</span>
            </div>
            <!-- import -->
            <div v-else class="downloadEnd">
              <img src="@/assets/imgs/cloudSpace/notification_slicing_complete.webp" alt="" />
              <span>{{ $t("downloaded") }}</span>
            </div>
          </div>
          <!-- mac下展示隐藏掉导入按钮 -->
          <!-- import -->
          <button class="file-edit" :class="[
            item.fileStateStr == 'import' && 'pointer',
            item.fileStateStr != 'import' && 'opacity',
          ]" :disabled="item.fileStateStr != 'import'" @click="importModel">
            <img src="@/assets/imgs/cloudSpace/Import_hover.webp" alt="" />
            <span>{{ $t("import") }}</span>
          </button>
          <!-- Delete -->
          <button class="file-edit delete pointer" @click="del" @mouseleave="leave" @mouseover="over">
            <img :src="getDelImg" alt="" />
            <span>{{ $t("delete") }}</span>
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { renameFile, delFiles } from "@/api/network/printer";
export default {
  name: "cloudSpatialInfoDialog",
  props: ["visible", "item"],
  data () {
    return {
      delHover: false,
      editInput: true,
      str: "",
    };
  },
  computed: {
    getDelImg () {
      return this.delHover
        ? require("@/assets/imgs/cloudSpace/Delete-click.webp")
        : require("@/assets/imgs/cloudSpace/Delete.webp");
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.str = this.item.fileNameStr;
        } else {
          this.str = "";
          this.editInput = true;
        }
      },
    },
  },
  mounted () { },
  methods: {
    editText () {
      this.editInput = false;
    },
    leave () {
      this.delHover = false;
    },
    over () {
      this.delHover = true;
    },
    handleClose (done) {
      this.$emit("update:visible", false);
    },
    fileDownload () {
      this.$emit("fileDownload", [this.item]);
    },
    async importModel () {
      this.$emit("importModel", this.item);
    },
    async nameSumbit () {
      const oldName = this.item.old_filename;
      const params = {
        id: this.item.id,
        name: this.str,
      };
      const res = await renameFile(params);
      if (res.code != 1) return;
      this.editInput = true;
      this.$emit("pushUserMd5", "update", res.data, oldName, "");
      this.$emit(
        "fileChange",
        "update",
        Object.assign(this.item, { old_filename: res.data })
      );
    },
    del () {
      this.$confirm(this.$t("confirm_delete"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning",
        center: true,
        customClass: this.$store.getters.GET_IS_DARK ? "dark-model" : "",
      })
        .then(() => {
          this.delModel();
        })
        .catch(() => {
          // this.$message.info("已取消删除!");
        });
    },
    async delModel () {
      const params = {
        idArr: [this.item.id],
      };
      const res = await delFiles(params);
      if (res.code != 1) return;
      this.$emit("pushUserMd5", "del", this.item.old_filename);
      this.$emit("fileChange", "del", this.item);
      this.handleClose();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 20px;
  }
}

.info-box {
  display: flex;
  gap: 20px;

  &-img {
    flex: 0 0 50%;
    background: #36363b;
    border-radius: 12px;
    // margin-right: 20px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &-text {
    width: 100%;
    // flex: 1;

    .info {
      gap: 24px;
      display: flex;
      flex-direction: column;
      margin-bottom: 53px;

      &-item {
        .title {
          color: var(--three-text-color);
          font-size: 13px;
          line-height: 18px;
        }

        .text {
          color: var(--first-text-color);
          font-size: 18px;
          line-height: 22px;
          display: flex;
          display: flex;
          align-items: flex-end;

          span {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            max-height: calc(1.5em * 2);
          }

          img {
            width: 16px;
            height: 16px;
            margin-left: 8px;
            cursor: pointer;
          }
        }
      }
    }

    .edit {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .state-icon {
        .downloading {
          display: flex;
          justify-content: center;
          align-items: center;

          ::v-deep .el-progress {
            flex: 1;
            margin-right: 8px;
          }

          .downloading-text {
            line-height: 18px;
            color: #3986ff;
            font-size: 13px;
          }
        }

        .downloadEnd {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            color: #3986ff;
          }
        }
      }

      .file-edit {
        width: 100%;
        border-radius: 16px;
        padding: 6px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--VI-color);
        border: none;

        img {
          margin-right: 8px;
        }

        span {
          color: #fffffe;
          line-height: 20px;
          font-size: 14px;
        }
      }

      .delete {
        border: 1px solid var(--three-btn-border);
        background: var(--dialog-background-color);

        span {
          color: var(--first-text-color);
        }
      }

      .delete:hover {
        border-color: #ff524d;

        span {
          color: #ff524d;
        }
      }

      .pointer {
        cursor: pointer;
      }

      .opacity {
        opacity: 0.4;
      }
    }
  }
}
@media screen and (max-width: 1145px) {
  ::v-deep {
    .el-dialog{
    // margin: 400;
      .el-dialog__body {
        overflow: auto;
        max-height: 390px;
        // margin: auto;
        .info-box {
          flex-direction: column;
        }
      }
    }
  }

}
</style>
